import { useNavigate } from 'react-router-dom';
import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/pages/_session.scss';

const yogaSteps = [
  {
    number: 1,
    title: 'Engage Your Core',
    description: 'Keep your core muscles activated throughout the flow. This builds strength and protects your lower back.'
  },
  {
    number: 2,
    title: 'Move with Intention',
    description: 'Each movement should be deliberate and controlled. Focus on proper form rather than speed.'
  },
  {
    number: 3,
    title: 'Build Heat and Power',
    description: 'The sequence is designed to build internal heat and strengthen your muscles progressively.'
  },
  {
    number: 4,
    title: 'Breathe Through Challenges',
    description: 'When poses become challenging, use your breath to stay calm and maintain focus.'
  }
];

const YogaFlowSession4: React.FC = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  const handleFinish = async () => {
    const token = localStorage.getItem('token');
    const session = {
      title: 'Yoga Flow Session 4',
      description: 'Completed Yoga Flow Session 4.',
      image: require('../assets/yoga.png').default || require('../assets/yoga.png'),
    };
    try {
      await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/completed-sessions`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(session)
      });
    } catch (err) {

    }
    navigate('/panel/dashboard/yoga-flow');
  };

  return (
    <div className={`session-page ${isDarkMode ? 'dark' : ''}`}>
      <div className="session-container">
        <header className="session-header">
          <a
            className="session-back-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              navigate(-1);
            }}
            title="Go back"
          >
            <span className="session-back-icon material-symbols-outlined">arrow_back</span>
          </a>
        </header>

        <main className="session-main">
          <div className="session-content-grid">
            {/* Video Section */}
            <div className="session-video-section">
              <h1 className="session-title">Session 4: Strength Flow</h1>
              <p className="session-description">
                Build physical strength and mental resilience with this dynamic yoga sequence. Challenge yourself while staying connected to your breath.
              </p>
              <div className="session-video-wrapper">
                <iframe
                  className="session-video"
                  src="https://www.youtube.com/embed/sTANio_2E0Q"
                  title="Session 4: Strength Flow"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            </div>

            {/* Instructions Section */}
            <div className="session-instructions-section">
              <div className="session-instructions-card">
                <h2 className="session-instructions-title">How to Practice</h2>
                <div className="session-steps">
                  {yogaSteps.map((step) => (
                    <div key={step.number} className="session-step">
                      <div className="session-step-number">
                        {step.number}
                      </div>
                      <div className="session-step-content">
                        <h3 className="session-step-title">{step.title}</h3>
                        <p className="session-step-description">{step.description}</p>
                      </div>
                    </div>
                  ))}
                </div>

                <button
                  className="session-complete-btn"
                  onClick={handleFinish}
                >
                  <span className="session-complete-icon material-symbols-outlined">check_circle</span>
                  Mark Session as Complete
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default YogaFlowSession4;

